import axios from '@/modules/axiosInterceptor';
import { apiUrlPrefix } from '@/modules/staticData';

export default {
  mixins: [apiUrlPrefix],
  data() {
    return {
      formLoading: false,
    };
  },
  methods: {
    // folders CRUD
    getFolder(folderObj, orientation) {
      this.formLoading = true;
      let params = {};
      if (folderObj && folderObj.id) {
        params = {
          directory: folderObj.id,
        };
      }
      if (typeof orientation !== 'undefined') {
        params.orientation = orientation;
      }
      const deferred = new Promise((resolve, reject) => {
        axios.get(`${apiUrlPrefix}media`, { params }).then((r) => {
          resolve(r.data.directory[0]);
        }).catch((r) => {
          const errorMessage = this.handleFormErrors(r.response.data);
          this.$root.$emit('notification-add', {
            content: `Failed to fetch the folder: ${errorMessage}`,
            variant: 'danger',
            ttl: 10000,
          });
          reject(errorMessage);
        }).finally(() => { this.formLoading = false; });
      });
      return deferred;
    },
    deleteFolder(folderObj) {
      const uid = folderObj.id;
      const deferred = new Promise((resolve, reject) => {
        this.$root.$emit('modal-show', {
          title: folderObj.name,
          body: 'Delete the folder permanently?',
          cbConfirm: () => {
            this.formLoading = true;
            axios.delete(`${apiUrlPrefix}media/directory`, { params: { id: uid } })
              .then(() => {
                this.$root.$emit('notification-add', { content: 'Folder deleted.' });
                resolve();
              })
              .catch((r) => {
                const errorMessage = this.handleFormErrors(r.response.data);
                this.$root.$emit('notification-add', {
                  content: `Unable to delete the folder: ${errorMessage}`,
                  variant: 'danger',
                  ttl: 10000,
                });
                reject(errorMessage);
              })
              .finally(() => { this.formLoading = false; });
          },
          confirmText: 'Delete',
          cancelText: 'Cancel',
        });
      });
      return deferred;
    },
    updateFolder(folderObj) {
      this.formLoading = true;
      const deferred = new Promise((resolve, reject) => {
        axios.put(`${apiUrlPrefix}media/directory`, { ...folderObj }).then((r) => {
          this.$root.$emit('notification-add', { content: 'Folder updated.' });
          resolve(r.data.directory);
        }).catch((r) => {
          const errorMessage = this.handleFormErrors(r.response.data);
          this.$root.$emit('notification-add', {
            content: `Failed to update the folder: ${errorMessage}`,
            variant: 'danger',
            ttl: 10000,
          });
          reject(errorMessage);
        }).finally(() => { this.formLoading = false; });
      });
      return deferred;
    },
    createFolder(folderObj) {
      this.formLoading = true;
      const deferred = new Promise((resolve, reject) => {
        axios.post(`${apiUrlPrefix}media/directory`, { ...folderObj }).then((r) => {
          this.$root.$emit('notification-add', { content: 'Folder created.' });
          resolve(r.data.directory);
        }).catch((r) => {
          const errorMessage = this.handleFormErrors(r.response.data);
          this.$root.$emit('notification-add', {
            content: `Unable to create a folder: ${errorMessage}`,
            variant: 'danger',
            ttl: 10000,
          });
          reject(errorMessage);
        }).finally(() => { this.formLoading = false; });
      });
      return deferred;
    },
    // files CRUD
    getFile(fileObj) {
      const uid = fileObj.id;
      const deferred = new Promise((resolve, reject) => {
        this.formLoading = true;
        axios.get(`${apiUrlPrefix}media/file/${uid}`)
          .then((r) => {
            resolve(r.data.file);
          })
          .catch((r) => {
            const errorMessage = this.handleFormErrors(r.response.data);
            this.$root.$emit('notification-add', {
              content: `Unable to fetch the file: ${errorMessage}`,
              variant: 'danger',
              ttl: 10000,
            });
            reject(errorMessage);
          })
          .finally(() => { this.formLoading = false; });
      });
      return deferred;
    },
    deleteFile(fileObj) {
      const uid = fileObj.id;
      const deferred = new Promise((resolve, reject) => {
        this.$root.$emit('modal-show', {
          title: fileObj.name,
          body: 'Delete the file permanently?',
          cbConfirm: () => {
            this.formLoading = true;
            axios.delete(`${apiUrlPrefix}media/file/${uid}`)
              .then(() => {
                this.$root.$emit('notification-add', { content: 'File deleted.' });
                resolve();
              })
              .catch((r) => {
                const errorMessage = this.handleFormErrors(r.response.data);
                this.$root.$emit('notification-add', {
                  content: `Unable to delete the file: ${errorMessage}`,
                  variant: 'danger',
                  ttl: 10000,
                });
                reject(errorMessage);
              })
              .finally(() => { this.formLoading = false; });
          },
          confirmText: 'Delete',
          cancelText: 'Cancel',
        });
      });
      return deferred;
    },
    updateFile(fileObj) {
      this.formLoading = true;
      const deferred = new Promise((resolve, reject) => {
        axios.put(`${apiUrlPrefix}media/file`, { ...fileObj }).then((r) => {
          this.$root.$emit('notification-add', { content: 'File updated.' });
          resolve(r.data.file);
        }).catch((r) => {
          const errorMessage = this.handleFormErrors(r.response.data);
          this.$root.$emit('notification-add', {
            content: `Failed to update the file: ${errorMessage}`,
            variant: 'danger',
            ttl: 10000,
          });
          reject(errorMessage);
        }).finally(() => { this.formLoading = false; });
      });
      return deferred;
    },
    createFile(fileObj, folderObj, formFile, type = 'image') {
      this.formLoading = true;
      // creat formdata bla bla bla
      const formData = new FormData();
      formData.append('file', formFile);
      formData.append('name', fileObj.name);
      formData.append('directory_id', folderObj.id);
      const deferred = new Promise((resolve, reject) => {
        axios.post(`${apiUrlPrefix}media/file/${type}`, formData,
          { headers: { 'Content-Type': 'multipart/form-data' } })
          .then((r) => {
            this.$root.$emit('notification-add', { content: 'File uploaded.' });
            resolve(r.data.file);
          // this.$router.push({ name: 'showUser', params: { id: r.data.user.id } });
          }).catch((r) => {
            const errorMessage = this.handleFormErrors(r.response.data);
            this.$root.$emit('notification-add', {
              content: `File ${fileObj.name} failed to upload: ${errorMessage}`,
              variant: 'danger',
              ttl: 10000,
            });
            reject(errorMessage);
          }).finally(() => { this.formLoading = false; });
      });
      return deferred;
    },
    createUrl(fileObj, folderObj, url) {
      this.formLoading = true;
      // creat formdata bla bla bla
      const formData = new FormData();
      formData.append('url', url);
      formData.append('name', fileObj.name);
      formData.append('directory_id', folderObj.id);
      const deferred = new Promise((resolve, reject) => {
        axios.post(`${apiUrlPrefix}media/file/url`, formData,
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
          .then((r) => {
            this.$root.$emit('notification-add', { content: 'URL saved.' });
            resolve(r.data.file);
          // this.$router.push({ name: 'showUser', params: { id: r.data.user.id } });
          }).catch((r) => {
            const errorMessage = this.handleFormErrors(r.response.data);
            this.$root.$emit('notification-add', {
              content: `URL ${fileObj.name} failed to save: ${errorMessage}`,
              variant: 'danger',
              ttl: 10000,
            });
            reject(errorMessage);
          }).finally(() => { this.formLoading = false; });
      });
      return deferred;
    },
  },
};
